/**
 * Tables PR — Row height equalizer
 *
 * Syncs row heights across all visible table cards so columns align.
 * Runs on load and when tabs change (checking/money/cds).
 */
(function () {
  function equalizeRows(wrapper) {
    const tables = wrapper.querySelectorAll('.tables__table');
    if (tables.length < 2) return;

    // Collect all row elements per table (thead th + tbody trs + bottom tr)
    const allRows = [];
    tables.forEach((table) => {
      const rows = [];
      const th = table.querySelector('.tables__th');
      if (th) rows.push(th);
      const bodyRows = table.querySelectorAll('.tables__tbody .tables__tr');
      bodyRows.forEach((r) => rows.push(r));
      const btRow = table.querySelector('.tables__tr-bt');
      if (btRow) rows.push(btRow);
      allRows.push(rows);
    });

    // Find max row count
    const maxRows = Math.max(...allRows.map((r) => r.length));

    // For each row index, reset heights then find max and apply
    for (let i = 0; i < maxRows; i++) {
      // Reset
      allRows.forEach((rows) => {
        if (rows[i]) rows[i].style.height = '';
      });

      // Find max height at this index
      let maxH = 0;
      allRows.forEach((rows) => {
        if (rows[i]) {
          const h = rows[i].getBoundingClientRect().height;
          if (h > maxH) maxH = h;
        }
      });

      // Apply
      if (maxH > 0) {
        allRows.forEach((rows) => {
          if (rows[i]) rows[i].style.height = maxH + 'px';
        });
      }
    }
  }

  function equalizeAll() {
    document.querySelectorAll('.tables__inner-wrapper').forEach(equalizeRows);
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeAll);
  } else {
    equalizeAll();
  }

  // Re-run when tabs change (tab-content becomes visible)
  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.tab-item');
    if (tab) {
      // Small delay for tab content to become visible
      setTimeout(equalizeAll, 100);
    }
  });

  // Re-run when expand/collapse toggles
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.open-hide-rows');
    if (btn) {
      setTimeout(equalizeAll, 100);
    }
  });
})();
